import React from "react";
import "../css/CoreValues.css";

const CoreValues = () => {
  return (
    <div className="core-values-container">
      <div className="content-layout">
        {/* Left Side Content */}
        <div className="left-content">
          <h3 className="heading">
            <span className="text-gray-900">COMPANY</span>
            <span className="text-red-600"> CORE VALUES</span>
          </h3>
          <div className="intro-section">
            <div className="icon-circle">
              <i className="fas fa-gavel icon-main"></i>
            </div>
            <p className="intro-text">
              Our company culture is defined by our Core Values
            </p>
          </div>
          <p className="description">
          Dr. Chek's core values form the foundation of its mission to revolutionize chronic disease management.
          </p>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon-box">
                  <i className={`fas ${value.icon} value-icon`} style={{ color: value.color }}></i>
                </div>
                <h2 className="value-title">{value.title}</h2>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
        
        {/* Right Side Image */}
        <div className="right-content">
          <img
            src="/images/Dr.Chek-02.png"
            alt="Circular diagram showing core values"
            className="core-image"
          />
        </div>
      </div>
    </div>
  );
};

const values = [
  {
    icon: "fa-universal-access",
    title: "Accessibility",
    description: "Dr. Chek is committed to democratizing healthcare.",
    color: "#DC2626",
  },
  {
    icon: "fa-bullseye",
    title: "Accuracy",
    description: "Dr. Chek believes that accuracy is paramount in healthcare.",
    color: "#DC2626",
  },
  {
    icon: "fa-lightbulb",
    title: "Innovation",
    description: "Dr. Chek is at the forefront of healthcare technology.",
    color: "#DC2626",
  },
];

export default CoreValues;
